export enum ActionTypes {
  CreateSubscriptionPayment = 'createSubscriptionPayment',
  CreateSubscriptionPaymentRequest = 'createSubscriptionPayment.request',
  CreateSubscriptionPaymentSuccess = 'createSubscriptionPayment.success',
  CreateSubscriptionPaymentFailure = 'createSubscriptionPayment.failure',
  ClearCreateSubscriptionPaymentErrors = 'clearCreateSubscriptionPaymentErrors',
}
